import Link from "@mui/material/Link"
import React from "react"

import i18n from "@/i18n"
import PublicLanguageDropdown from "@/pages/public/language_dropdown"
import backgroundImage from "@/pages/sign_in/background.jpg"
import logo from "@/shared/logo.svg"

type AuthLayoutProps = {
  children: React.ReactNode
  topNav?: React.ReactNode
  cardClassName?: string
  containerClassName?: string
  testIdPrefix: string
}

const AuthLayout: React.FC<AuthLayoutProps> = ({
  children,
  topNav,
  cardClassName = "flex flex-col justify-center items-center p-12 rounded-lg bg-white shadow-md",
  containerClassName = "flex h-screen w-screen bg-gray-200",
  testIdPrefix,
}) => {
  return (
    <div className={containerClassName} data-testid={`${testIdPrefix}-page`}>
      <div
        className="h-screen w-1/3 bg-cover bg-center fixed top-0 left-0 flex items-start justify-center"
        style={{ backgroundImage: `url(${backgroundImage})` }}
      >
        <img src={logo} alt="Tabb" className="mt-12" />
      </div>

      <div className="ml-[33%] w-2/3 min-h-screen flex flex-col p-8 relative">
        {!!topNav && <div className="flex justify-end mb-auto pb-8">{topNav}</div>}

        <div className="flex justify-center items-center flex-1">
          <div className={cardClassName}>{children}</div>
        </div>

        <div className="flex justify-center mt-auto pt-8" data-testid={`${testIdPrefix}-footer`}>
          <div className="text-gray-500 text-center max-w-sm text-xs">
            {i18n.t("app.auth.login.recaptcha_notice")}{" "}
            <span className="font-bold">{i18n.t("app.auth.login.tabb")}</span>{" "}
            <Link href="/privacy_policy" underline="hover" data-testid={`${testIdPrefix}-privacy-link`}>
              {i18n.t("app.auth.login.privacy_policy")}
            </Link>{" "}
            {i18n.t("app.auth.login.and")}{" "}
            <Link href="/terms" underline="hover" data-testid={`${testIdPrefix}-terms-link`}>
              {i18n.t("app.auth.login.terms_of_service")}
            </Link>
          </div>
        </div>

        <div className="absolute bottom-8 right-8">
          <PublicLanguageDropdown variant="light" menuPlacement="above" />
        </div>
      </div>
    </div>
  )
}

export default AuthLayout
